<lib-item [id]="id"></lib-item>